import React, { useEffect } from "react";
import './App.scss';

function App() {
  useEffect(() => {
    window.location.href = "https://csa-toolbox.vercel.app";
  }, []);

  return (
    <div className="App">
      <p style={{ textAlign: 'center', marginTop: '2rem' }}>
        Redirecting to CSA Toolbox...
      </p>
    </div>
  );
}

export default App;
